import type { JsonValue, Provider, ResolutionDetails } from '@openfeature/web-sdk';

export class ValuePathProvider implements Provider {
  readonly metadata = { name: 'valuepath' };
  private flags: Record<string, boolean>;

  constructor(flags: Record<string, boolean>) {
    this.flags = flags;
  }

  async initialize(): Promise<void> {
    // No-op — flags already provided via constructor from the first load
  }

  resolveBooleanEvaluation(flagKey: string, defaultValue: boolean): ResolutionDetails<boolean> {
    const known = flagKey in this.flags;
    return {
      value: known ? this.flags[flagKey] : defaultValue,
      reason: known ? 'TARGETING_MATCH' : 'DEFAULT',
    };
  }

  resolveStringEvaluation(_flagKey: string, defaultValue: string): ResolutionDetails<string> {
    return { value: defaultValue, reason: 'DEFAULT' };
  }

  resolveNumberEvaluation(_flagKey: string, defaultValue: number): ResolutionDetails<number> {
    return { value: defaultValue, reason: 'DEFAULT' };
  }

  resolveObjectEvaluation<T extends JsonValue>(_flagKey: string, defaultValue: T): ResolutionDetails<T> {
    return { value: defaultValue, reason: 'DEFAULT' };
  }
}
